import gql from 'graphql-tag'

export const ProgramsTableQuery = gql`
	query programsTableQuery {
		programs {
			_id
			name
			team {
				_id
				path
				n
			}
			playlists {
				_id
			}
		}
	}
`

export const ProgramDetailsQuery = gql`
	query program($id: String!) {
		programById(_id: $id) {
			_id
			name
			programPlaylistIds
			playlists {
				_id
				name
				scheduleV3 {
					rule
					duration
					weight
				}
				artwork
				crossfade
				canForceTrack
				manualSelectionEnabled
				isCurrent
				playlist {
					_id
					n
					a
					created
					idPath
					tracks {
						genre
						optimizedMono {
							duration
						}
						optimizedStereo {
							duration
						}
						stereoNoMeta {
							sizeBytes
						}
						monoNoMeta {
							sizeBytes
						}
					}
				}
			}
			teamId
			team {
				_id
				path
				n
			}
			commentCount
			devicesCount
			ownerId
			createdBy {
				date
				name
			}
			updatedBy {
				date
				name
			}
			manifestVersion
			owner {
				_id
				firstName
				lastName
			}
		}
	}
`

// devices playing the program, to show the scheduler "now" in their timezone
export const ProgramScheduleDevicesQuery = gql`
	query programScheduleDevices($id: String!) {
		programById(_id: $id) {
			_id
			zones {
				_id
				device {
					_id
					name
					nickname
					timeZone
				}
			}
			thirdPartyDevices {
				_id
				name
				nickname
				timeZone
			}
		}
	}
`

export const ProgramDetailsDevicesQuery = gql`
	query fetchProgramDetails($id: String!) {
		programById(_id: $id) {
			_id
			thirdPartyDevices {
				_id
				name
				onlineDate
				type
			}
			zones {
				_id
				name
				device {
					_id
					name
					nickname
					OS
					onlineDate
					onlineState
					lastConnection
					dlState
					contentUpdated
					zones {
						_id
						name
						playState
						program {
							_id
							updatedBy {
								date
							}
						}
						messagePrograms {
							_id
							updatedBy {
								date
							}
						}
					}
				}
			}
		}
	}
`
